<app-modal-frame [headerText]="HEADER" (emitExit)="clickExit()">
  <div class="content">
    <app-contact-card [rowData]="contactCardData"></app-contact-card>
    <app-availability-card
      [cardData]="availabilityCardData"
    ></app-availability-card>
    <app-indicators-card
      [indicatorData]="indicatorCardData"
    ></app-indicators-card>
  </div>
</app-modal-frame>
